import { render, staticRenderFns } from "./RoomInspectionHistoryModal.vue?vue&type=template&id=3252a4f9&"
import script from "./RoomInspectionHistoryModal.vue?vue&type=script&lang=js&"
export * from "./RoomInspectionHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports